import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fb47284"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-body" }
const _hoisted_2 = { class: "item-title" }
const _hoisted_3 = { class: "item-title-inner" }
const _hoisted_4 = { class: "text-grey" }

import ProviderDistance from '@/model/ProviderDistance';
import {useRouter} from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'NearbyCustomerListItem',
  props: {
  data: {
    type: ProviderDistance,
    required: true,
  },
},
  setup(__props, { expose: __expose }) {


const router = useRouter();
function detail(provider: ProviderDistance) {
  router.push({name: 'customer_details', params: {id: provider.KundenNr.toString()}});
}

__expose({
  detail,
});

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createBlock(_component_v_list_item, {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (detail(__props.data))),
    key: __props.data.KundenNr,
    class: "order-item py-5"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_list_item_title, null, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(__props.data.Kunde.Kundname), 1),
                _createElementVNode("span", _hoisted_4, [
                  _createElementVNode("small", null, "#" + _toDisplayString(__props.data.KundenNr), 1)
                ])
              ], undefined, true),
              _: 1
            }),
            (__props.data.Kunde.PostAnschrift)
              ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(`${__props.data.Kunde.PostAnschrift[0]?.Plz ?? ''} ${__props.data.Kunde.PostAnschrift[0]?.Ort ?? ''}`), 1)
                  ], undefined, true),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_list_item_subtitle, null, {
              default: _withCtx(() => [
                _createTextVNode(" ca. " + _toDisplayString(Math.ceil(__props.data.DistanzKm)) + " km ", 1)
              ], undefined, true),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_v_chip, {
              class: "px-3",
              variant: "outlined",
              color: __props.data.Kunde.color
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { class: "mr-1" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.data.Kunde.icon), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createTextVNode(),
                _createElementVNode("strong", null, _toDisplayString(__props.data.Kunde.GroupName), 1)
              ], undefined, true),
              _: 1
            }, 8, ["color"])
          ])
        ])
      ])
    ], undefined, true),
    _: 1
  }))
}
}

})